module["exports"] = [
  "?#? #?#"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/en_CA/address/postcode.js
 ** module id = 500
 ** module chunks = 0
 **/